/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Číselník příkazů pro zařízení.
 * @enum {string}
 * @name CommandEnum
 */
export default {
  POWER_OFF: 'POWER_OFF',
  POWER_ON: 'POWER_ON',
  REBOOT: 'REBOOT',
  REPORT: 'REPORT'
};
